<div class="relative flex flex-col gap-10 p-6 bg-neutrals-0 rounded-2xl w-full">
  <button
    type="button"
    class="absolute top-6 right-6 bg-transparent"
    aria-label="Cerrar"
    (click)="onCancel()"
  >
    <ui-icon
      name="close"
      size="24"
      mobile-size="24"
      fill="neutrals-900"
    ></ui-icon>
  </button>

  <div class="flex flex-col gap-4">
    <!-- Figma 7322:41304 "Illustration/download" — published as i-download in
         nanaykuna-ui-kit 1.8.21 (absent through 1.8.20; this ticket bumped the
         dependency once it became available). The icon is a fully hardcoded
         multi-color SVG (its own per-path fills) — the `fill` input has no
         visible effect on it and is passed only because the prop is required. -->
    <div class="flex justify-center">
      <ui-illustrative-icon
        name="i-download"
        size="80"
        mobile-size="80"
        fill="primary-400"
      ></ui-illustrative-icon>
    </div>

    <div class="flex flex-col gap-2">
      <ui-headline
        id="download-orders-dialog-title"
        class="text-center"
        type="h20"
        text-color="neutrals-900"
        font-weight="semibold"
        content="Descargar archivo"
      ></ui-headline>

      <ui-paragraph
        *ngIf="data.hasFilters; else noFiltersCopy"
        class="text-center"
        type="p16"
        font-weight="regular"
        text-color="neutrals-700"
        content="Se descargará un archivo Excel con los registros que coincidan con los filtros de búsqueda aplicados."
      ></ui-paragraph>
      <ng-template #noFiltersCopy>
        <p class="text-center ui-paragraph-type-p16 text-neutrals-700">
          Se descargará un archivo Excel con los registros correspondientes al
          <span class="font-semibold">día de hoy</span>
        </p>
      </ng-template>
    </div>

    <div
      *ngIf="data.hasFilters"
      class="flex flex-col gap-2 p-5 rounded-lg bg-neutrals-100 border border-neutrals-300"
    >
      <div *ngIf="hasDateFilter" class="flex justify-between gap-2">
        <ui-paragraph
          type="p14"
          font-weight="regular"
          text-color="neutrals-600"
          content="Período:"
        ></ui-paragraph>
        <ui-paragraph
          class="text-right"
          type="p14"
          font-weight="regular"
          text-color="neutrals-600"
          [content]="
            (data.applied.dateFrom | displayDate) +
            ' al ' +
            (data.applied.dateTo | displayDate)
          "
        ></ui-paragraph>
      </div>
      <div *ngIf="hasClientFilter" class="flex justify-between gap-2">
        <ui-paragraph
          type="p14"
          font-weight="regular"
          text-color="neutrals-600"
          content="Ferretería:"
        ></ui-paragraph>
        <ui-paragraph
          class="text-right"
          type="p14"
          font-weight="regular"
          text-color="neutrals-600"
          [content]="
            clientSelectionCount +
            (clientSelectionCount === 1 ? ' filtro' : ' filtros')
          "
        ></ui-paragraph>
      </div>
      <div *ngIf="hasUrgencyFilter" class="flex justify-between gap-2">
        <ui-paragraph
          type="p14"
          font-weight="regular"
          text-color="neutrals-600"
          content="Plazo de vencimiento:"
        ></ui-paragraph>
        <ui-paragraph
          class="text-right"
          type="p14"
          font-weight="regular"
          text-color="neutrals-600"
          [content]="
            urgencySelectionCount +
            (urgencySelectionCount === 1 ? ' filtro' : ' filtros')
          "
        ></ui-paragraph>
      </div>
      <div *ngIf="hasOrderNumberFilter" class="flex justify-between gap-2">
        <ui-paragraph
          type="p14"
          font-weight="regular"
          text-color="neutrals-600"
          content="N° de registro:"
        ></ui-paragraph>
        <ui-paragraph
          class="text-right"
          type="p14"
          font-weight="regular"
          text-color="neutrals-600"
          [content]="data.applied.orderNumber"
        ></ui-paragraph>
      </div>
    </div>

    <ngx-skeleton-loader *ngIf="isLoadingCount" />
    <ui-paragraph
      *ngIf="!isLoadingCount"
      class="text-center"
      type="p16"
      font-weight="regular"
      text-color="neutrals-700"
      [content]="totalRecordsLine"
    ></ui-paragraph>
  </div>

  <div class="flex flex-col gap-2">
    <ui-button
      type="primary"
      responsive="false"
      font-weight="medium"
      icon-preffix="download"
      data-testid="descargar-excel-confirm-button"
      [customSizeConfig]="modalButtonSizeConfig"
      [buttonText]="isLoadingExport ? 'Descargando' : 'Descargar Excel'"
      loader-position="suffix"
      [enabled]="!isOverMaxLookback && !hasNoRecordsToExport"
      [isLoading]="isLoadingExport"
      (click)="onConfirm()"
    ></ui-button>
    <ui-button
      type="secondary"
      responsive="false"
      font-weight="medium"
      [customSizeConfig]="modalButtonSizeConfig"
      button-text="Cancelar"
      [enabled]="!isLoadingExport"
      [isLoading]="false"
      (click)="onCancel()"
    ></ui-button>
  </div>
</div>
